<template>
  <q-dialog
    :visible="isVisible"
    title="新增"
    width="50%"
    :innerScroll="false"
    :loading="loadingBtn"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" size="mini">
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品编码:" prop="productCode">
            <wait-add-product-select v-model="form.productCode" @select="handleProductSelect" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称:">
            <el-input v-model="form.productName" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="基础零售价:" prop="retailPrice">
            <el-input-number v-model="form.retailPrice" :precision="0" :min="0" :controls="false" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="A类价系数:" prop="dailyRetailPrice">
            <el-input-number v-model="form.dailyRetailPrice" :precision="5" :min="0" :controls="false" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="清仓销售价系数:" prop="discountPriceClear">
            <el-input-number v-model="form.discountPriceClear" :precision="5" :min="0" :controls="false" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="调整原因:" prop="reason">
            <el-input type="textarea" :rows="4" v-model="form.reason" maxlength="300" show-word-limit placeholder="请输入调整原因"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import WaitAddProductSelect from './wait-add-product-select.vue'

export default {
  name: 'RetailPriceAddDialog',
  components: { WaitAddProductSelect },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      loadingBtn: false,
      form: {
        productCode: '',
        productName: '',
        retailPrice: undefined,
        dailyRetailPrice: undefined,
        discountPriceClear: undefined,
        reason: '',
      },
      rules: {
        productCode: [{ required: true, message: '请选择产品编码', trigger: 'change' }],
        reason: [{ required: true, message: '请输入调整原因', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    handleProductSelect(item) {
      this.form.productName = item ? item.productName : ''
    },
    onConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        this.loadingBtn = true
        this.$q.product.addProductRetailPrice({ data: this.form }).then((res) => {
          if (res.code === '200') {
            this.$message.success('新增成功')
            this.isVisible = false
            this.$emit('success')
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.loadingBtn = false
        })
      })
    },
  },
}
</script>
